export const ASSET_USAGE_RECORDS_MODULE_NAME = "assetUsageRecords";

export const ASSETS_WRITE_OFF_DEADLINE_DAY = 4;

// Set to true to restore the detailed write-off error modal.
export const IS_WRITE_OFF_ERROR_MODAL_ENABLED = false;
